import { useMemo } from 'react'

import {
  pendingApprovalFilter,
  reportDateFilter,
  statusFilter,
  useCategoryFilter,
  useCurrencyFilter,
  useEmployeeIdsFilter,
  useLegalEntityIdsFilter,
  useSubcategoryFilter,
} from 'modules/expenses/components/expenses/DataCollection/filters'
import { reportedByFilter } from 'modules/expenses/components/my_expenses/DataCollection/_Filters/reportedByFilter'

interface UseGroupsFiltersProps {
  companyId: string
  canUsePerDiems: boolean
  isMyExpenses?: boolean
}

export const useGroupsFilters = ({
  companyId,
  canUsePerDiems,
  isMyExpenses = false,
}: UseGroupsFiltersProps) => {
  const categoryFilter = useCategoryFilter({ companyId, canUsePerDiems })
  const currencyFilter = useCurrencyFilter()
  const employeeIdsFilter = useEmployeeIdsFilter(companyId)
  const legalEntityIdsFilter = useLegalEntityIdsFilter()
  const subcategoryFilter = useSubcategoryFilter(companyId)

  return useMemo(
    () => ({
      reviewRequestAt: reportDateFilter(),
      category: categoryFilter,
      currency: currencyFilter,
      ...(isMyExpenses ? { reportedBy: reportedByFilter() } : {}),
      ...(!isMyExpenses ? { employeeIds: employeeIdsFilter } : {}),
      ...(!isMyExpenses ? { legalEntityIds: legalEntityIdsFilter } : {}),
      ...(!isMyExpenses ? { pendingApproval: pendingApprovalFilter() } : {}),
      status: statusFilter(),
      subcategory: subcategoryFilter,
    }),
    [
      categoryFilter,
      currencyFilter,
      employeeIdsFilter,
      isMyExpenses,
      legalEntityIdsFilter,
      subcategoryFilter,
    ]
  )
}
